'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Bottle = require('../classes/Bottle');

var _Bottle2 = _interopRequireDefault(_Bottle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  install: function install(Vue) {
    Vue.prototype.bottle = new _Bottle2.default();
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/ctxs-vue-plugins/dist/plugins/BottlePlugin.js
// module id = OVzB
// module chunks = 0